import { render, staticRenderFns } from "./saml-login.vue?vue&type=template&id=1d6d55c8&"
import script from "./saml-login.vue?vue&type=script&lang=js&"
export * from "./saml-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports